@if (showLoader()) {
  <app-page-loader></app-page-loader>
}
<router-outlet></router-outlet>
<app-status-modal />
